"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const react_router_2 = require("react-router");
const react_use_1 = require("react-use");
const zustandStore_1 = require("../../../../zustandStore");
const errorPage_1 = __importDefault(require("../../errorPage"));
const banner_1 = require("../common/banner");
const styledMessage_1 = require("../common/styledMessage");
const title_1 = require("../common/title");
const authForm_1 = __importDefault(require("../loginform/authForm"));
const activationForm_1 = __importDefault(require("./activationForm"));
const lexico = new lexico_1.default();
const ActivateForm = () => {
    const theme = (0, material_1.useTheme)();
    const location = (0, react_router_1.useLocation)();
    const isInvitation = !location.pathname.includes('register');
    const navigate = (0, react_router_2.useNavigate)();
    const initialData = (0, react_router_2.useLoaderData)();
    const { data, isLoading, error } = initialData;
    const { showTwoFactorAuth } = (0, zustandStore_1.useZustand)(state => state.registration);
    (0, react_use_1.useEffectOnce)(() => {
        if (!error) {
            return;
        }
        void navigate('/signin/message', {
            state: {
                heading: lexico.tr('Sorry, we are having technical difficulties. Please try again later.'),
                message: lexico.trc('Error message', 'The link to activate your account is invalid or has expired. Please check with the person who invited you to get another invitation.'),
            },
        });
    });
    if (!data && !isLoading) {
        return (0, jsx_runtime_1.jsx)(errorPage_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)(authForm_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Container, { style: {
                width: '360px',
                padding: 0,
                border: `1px solid ${theme.palette.tsGoColor.grayLightest}`,
                backgroundColor: theme.palette.tsGoColor.white,
            }, children: [(0, jsx_runtime_1.jsx)(banner_1.Banner, { className: "banner signin" }), (0, jsx_runtime_1.jsx)(title_1.Title, { children: lexico.trc('Component title', isInvitation
                        ? 'Accept your invitation to join'
                        : showTwoFactorAuth
                            ? 'Activate your account'
                            : 'Setup your password') }), (0, jsx_runtime_1.jsx)(activationForm_1.default, {}), isInvitation && ((0, jsx_runtime_1.jsxs)(styledMessage_1.StyledMessage, { children: ["By proceeding to create your account and use Tradeshift Go, you are agreeing to our \u00A0", (0, jsx_runtime_1.jsx)(material_1.Link, { underline: "none", href: "/tos", target: "_blank", rel: "noreferrer", children: "Terms of Service and Privacy Policy" }), "."] }))] }) }));
};
exports.default = ActivateForm;
